import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BriefsKey } from 'constants/queryKeys';
import { updateTask } from 'services/taskService';
import {
  error as renderError,
  success as renderSuccess
} from 'helpers/toaster';

const useUpdateBrief = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ taskId, payload }) => updateTask(taskId, payload),

    // On success, update cache DIRECTLY with server response
    onSuccess: (response, { taskId }) => {
      const updatedTask = response?.data?.task;

      if (!updatedTask) {
        return;
      }

      // Update ALL briefs queries in the cache directly
      queryClient.setQueriesData(
        {
          predicate: (query) => {
            // Match any query key that starts with BriefsKey
            return Array.isArray(query.queryKey) && query.queryKey[0] === BriefsKey;
          }
        },
        (oldData) => {
          if (!oldData || !oldData.pages) {
            return oldData;
          }

          // Update the task in all pages
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              data: {
                ...page.data,
                tasks: page.data?.tasks?.map((task) =>
                  task.id === taskId ? updatedTask : task
                ) || [],
              },
            })),
          };
        }
      );

      renderSuccess('Updated successfully!');
    },

    // On error, show error message
    onError: (error) => {
      renderError('Cannot update task!');
    },
  });
};

export default useUpdateBrief;
